import styled from 'styled-components';
import { DialogContent, DialogDescription } from 'components/dialog/dialog';
import { MASKED_TEXT_CLASS } from 'analytics/constants';

export const WarningDialogContent = styled(DialogContent).attrs({
  className: 'max-w-md',
})``;

export const WarningDialogDescription = styled(DialogDescription).attrs<{ $masked: boolean }>(
  ({ $masked }) => ({
    className: $masked ? MASKED_TEXT_CLASS : '',
  })
)<{ $masked: boolean }>``;

export const WarningDialogDivider = styled.hr.attrs({
  className: 'border-border',
})``;

export const RemoteSteps = styled.ol.attrs({
  className: 'space-y-5',
})``;

export const RemoteStep = styled.li.attrs({
  className: 'flex gap-3',
})``;

export const RemoteStepBody = styled.div.attrs({
  className: 'space-y-1',
})``;

export const RemoteStepTitle = styled.p.attrs({
  className: 'text-sm font-semibold',
})``;

export const RemoteStepBullets = styled.ul.attrs({
  className: 'list-disc pl-4 space-y-0.5',
})``;

export const RemoteStepOptions = styled.div.attrs({
  className: 'space-y-2',
})``;

export const RemoteStepOption = styled.div.attrs({
  className: 'space-y-0.5',
})``;
